import ActionKeys from '../actions/ActionKeys';

const initialState = {
    detail: null,
};

const initialStateCopy = {
    isCopy: false,
};

const initStateAddPackage = {
    openAddPackage: null
}

export const exportGoodsReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionKeys.EXPORT_GOODS.GET_DETAIL:
            return {
                ...state,
                detail: action.data,
            };
        default:
            return state;
    }
};


export const isCoppyExportReducer = (state = initialStateCopy, action) => {
    switch (action.type) {
        case ActionKeys.EXPORT_GOODS.IS_COPY:
            return {
                ...state,
                isCopy: action.data,
            };
        default:
            return state;
    }
};


export const packagesExportReducer = (state = initStateAddPackage, action) => {
    switch (action.type) {
        case ActionKeys.EXPORT_GOODS.OPEN_ADD_PACKAGE:
            return {
                ...state,
                openAddPackage: action.payload.openAddPackage
            };
        default:
            return state;
    }
}